import { cn } from "@utils/Cn";

export const PageTemplate = ({
  children,
  className = "",
  leftSectionClassName = "",
  rightSectionClassName = "",
}) => {
  return (
    <div
      className={cn(
        "flex h-full relative flex-col",
        "lg:flex-row lg:bg-zinc-50",
        className
      )}
    >
      {children}
    </div>
  );
};

export const PageBody = ({ children, className = "", innerClassName = "" }) => {
  return (
    <div
      className={cn(
        "lg:px-4 pt-4 grow flex-1",
        "lg:px-20 lg:py-12 lg:overflow-y-auto",
        className
      )}
    >
      <div
        className={cn(
          "w-full max-w-md mx-auto pb-8",
          "lg:pb-0 lg:ml-auto lg:mr-0 lg:pt-8",
          innerClassName
        )}
      >
        {children}
      </div>
    </div>
  );
};

export const PageFooter = ({
  children,
  className = "",
  innerClassName = "",
}) => {
  return (
    <div
      className={cn(
        // Static on mobile: the footer flows to the bottom of the page below the card
        // widget rather than pinning over the fields. Sticky sidebar column on lg.
        "border-zinc-200 p-5 bg-white static lg:sticky lg:bottom-0 lg:left-0 lg:right-0 border-t",
        "lg:px-20 lg:py-12 lg:overflow-y-auto lg:top-0 lg:h-full lg:flex-1 lg:border-l lg:border-zinc-300 lg:border-t-0",
        className
      )}
    >
      <div
        className={cn(
          "w-full max-w-md mx-auto",
          "lg:mr-auto lg:ml-0 lg:pt-8",
          innerClassName
        )}
      >
        {children}
      </div>
    </div>
  );
};
